var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBarcode = function SvgIconBarcode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.216 0.253906H2.69024C1.20597 0.253906 0 1.32094 0 2.63421V21.6561C0 22.9694 1.20597 24.0364 2.69024 24.0364H31.216C32.7003 24.0364 33.9063 22.9694 33.9063 21.6561V2.63421C33.9063 1.32094 32.7003 0.253906 31.216 0.253906ZM32.5611 21.6561C32.5611 22.3127 31.9581 22.8668 31.1928 22.8668H2.66704C1.92491 22.8668 1.29873 22.3333 1.29873 21.6561V2.63421C1.29873 1.97757 1.90172 1.42354 2.66704 1.42354H31.1928C31.935 1.42354 32.5611 1.95705 32.5611 2.63421V21.6561Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7782 3.84473H28.4563V20.4658H29.7782V3.84473Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7196 3.84473H24.3977V16.8748H25.7196V3.84473Z",
    fill: "#A3A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.661 3.84473H20.3391V16.8748H21.661V3.84473Z",
    fill: "#A3A3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6024 3.84473H16.2805V16.8748H17.6024V3.84473Z",
    fill: "#A3A3A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5438 3.84473H12.2219V20.4658H13.5438V3.84473Z",
    fill: "#A3A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50845 3.84473H8.18652V16.8748H9.50845V3.84473Z",
    fill: "#A3A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44986 3.84473H4.12793V16.8748H5.44986V3.84473Z",
    fill: "#A3A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7196 19.2759H24.3977V20.4455H25.7196V19.2759Z",
    fill: "#A3A3A3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.661 19.2759H20.3391V20.4455H21.661V19.2759Z",
    fill: "#A3A3A3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6024 19.2759H16.2805V20.4455H17.6024V19.2759Z",
    fill: "#A3A3A3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50845 19.2759H8.18652V20.4455H9.50845V19.2759Z",
    fill: "#A3A3A3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44986 19.2759H4.12793V20.4455H5.44986V19.2759Z",
    fill: "#A3A3A3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBarcode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-barcode.3a57571b.svg";
export { ForwardRef as ReactComponent };